import React, { FC } from 'react'
import {
  Select as ChSelect,
  SelectProps as ChSelectProps,
} from '@chakra-ui/react'

type Option = {
  name: string
  value: string
}

export type SelectProps = {
  options: Option[]
  onChange: ChSelectProps['onChange']
  type?: string
  value?: string
  placeholder?: string
} & ChSelectProps

export const Select: FC<SelectProps> = ({
  options,
  variant: _,
  isDisabled,
  placeholder = 'Select an option',
  value: possiblyNullValue,
  ...props
}) => {
  const value = possiblyNullValue === null ? undefined : possiblyNullValue

  return (
    <ChSelect
      {...props}
      placeholder={placeholder}
      value={value}
      disabled={isDisabled}
      isDisabled={isDisabled}
      // Manually set placeholder as Chakra UI
      // renders selected option as a div (no value attribute to hook into in css)
      {...(!value && { color: 'softestBlack' })}
    >
      {options.map(({ name, value }) => (
        <option key={value} value={value}>
          {name}
        </option>
      ))}
    </ChSelect>
  )
}
